export const USER_NOTIFICATION = 'notifications';
export const GET_USER_NOTIFICATION = `${USER_NOTIFICATION}/getUserNotifications`;
export const DELETE_USER_NOTIFICATION = `${USER_NOTIFICATION}/deleteUserNotification`;
export const REVIEW_SKILL_CHANGE_NOTIFICATION = `${USER_NOTIFICATION}/reviewSkillChangeNotification`;